module.exports = __webpack_public_path__ + "img/medicine-box.2c499c1f.svg";